import React, { useState } from 'react';
import Header from '../Header'; // Ensure the Header component path is correct
import ContactUsFooter from '../ContactUs/ContactUsFooter'; // Ensure the Footer component path is correct
import './FeedbackPage.css';

const FeedbackPage = () => {
    const [rating, setRating] = useState(null); // For tracking selected rating
    const [comment, setComment] = useState(""); // For storing feedback comment

    const handleSubmit = (event) => {
        event.preventDefault();
        console.log(`Rating: ${rating}`);
        console.log(`Feedback Comment: ${comment}`);
        console.log('Feedback submitted successfully.');
    };

    const ratingIcons = [
        { label: 'Excellent', icon: '/pictures/excellent.png', color: 'green' },
        { label: 'Good', icon: '/pictures/good.png', color: 'lightgreen' },
        { label: 'Medium', icon: '/pictures/medium.png', color: 'yellow' },
        { label: 'Poor', icon: '/pictures/poor.png', color: 'orange' },
        { label: 'Very Bad', icon: '/pictures/verybad.png', color: 'red' }
    ];

    return (
        <div className="feedback-page-container">
            <Header />
            <div className="feedback-modal">
                <h1>Send us your feedback!</h1>
                <form onSubmit={handleSubmit} className="feedback-form">
                    <p>
                        Based on your recent experience with our website, how likely are you
                        to recommend us to a colleague or friend?
                    </p>
                    <div className="rating-buttons">
                        {ratingIcons.map((ratingOption, index) => (
                            <button
                                key={index}
                                type="button"
                                className={`rating-button ${rating === index ? 'active' : ''}`}
                                onClick={() => setRating(index)}
                            >
                                <img 
                                    src={ratingOption.icon} 
                                    alt={ratingOption.label} 
                                    className="rating-icon" 
                                    style={{ borderColor: ratingOption.color }}
                                />
                                <span>{ratingOption.label}</span>
                            </button>
                        ))}
                    </div>
                    <label htmlFor="feedback-comment">
                        Would you like to add a comment?
                    </label>
                    <textarea
                        id="feedback-comment"
                        rows="4"
                        placeholder="Share your thoughts..."
                        value={comment}
                        onChange={(e) => setComment(e.target.value)} // Update comment state
                    ></textarea>
                    <button type="submit" className="feedback-submit-button">
                        Submit
                    </button>
                </form>
            </div>
            <ContactUsFooter />
        </div>
    );
};

export default FeedbackPage;